<template>
    <div style="height:100%; display: flex;">
        <transition name="fade">
          <div style="margin: 0 20px" >
          <el-badge :value=value1>
          <div @click="openInfo()"><i :style="style.icon" :class="icon ? icon : 'el-icon-chat-dot-square'"></i></div>
          </el-badge>
          </div>
        </transition>
        <el-dialog title="消息通知" :visible.sync="open" width="780px" append-to-body>
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="消息" name="first"><newsBar :userId="userId"></newsBar></el-tab-pane>
                <el-tab-pane label="公告通知" name="second"><noticeBar></noticeBar></el-tab-pane>
            </el-tabs>
        </el-dialog>
    </div>

</template>
<script>
    import {queryByPage} from '@/api/words/words';
    import { getInfo } from "@/api/login";
    import noticeBar from "./notice";
    import  newsBar from "./news.vue";
    export default {
        props: {
            options: {
                type: Object,
                default() {
                    return {
                        text: '默认'
                    };
                }
            }
        },
        data() {
            return {
                userId:undefined,
                activeName: 'first', //;页签默认显示第一个
                List:[],//消息列表
                open: false , //模态框
                value1:"",
                icon:this.options.icon,
                style:{
                   icon:[
                   {fontSize: this.options.iconSize},
                   ]
                },
              queryParams:{
                toUserId:undefined
              }
            };
        },
        components: {
            noticeBar,
            newsBar
        },
      created() {
          this.getUserId();
          this.getList();
      },
      methods: {
        //获取消息信息
        getList() {
          this.queryParams.toUserId = this.userId;
          queryByPage(this.queryParams).then((response) => {
            this.List = response.data.list;
            var arr = [];
            for (let i = 0; i < response.data.list.length; i++) {
              if (response.data.list[i].status == 0){
                arr.push(response.data.list[i])
              }
            }
            this.value1 = arr.length;
          });

        },
          //获取当前用户id
          getUserId(){
            getInfo().then((response) =>{
              this.userId = response.data.userId;
            })
          },
            openInfo(){
                this.open = true;
                this.getList();
            },
            handleClick(tab, event) {
                console.log(tab, event);
                this.getList();
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/NoticeBar/index.vue